import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import Cookies from "js-cookie";

const userToken = Cookies.get("jwt");
const user = JSON.parse(localStorage.getItem("user"));

const state = () => ({
  isLoggedIn: user ? true : false,
  user,
  userToken,
  errors: []
});

export default {
  state,
  actions,
  getters,
  mutations
};
